<div class="tw-flex tw-flex-col tw-gap-4 tw-p-4">
    <!-- Form section shown only when articleId exists -->
    @if (articleId()) {
        <form
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
            class="tw-flex tw-flex-col tw-gap-4">
            <div
                formArrayName="carriers"
                class="tw-flex tw-flex-wrap tw-gap-4">
                @for (
                    carrier of carriers.controls;
                    track carrier;
                    let i = $index
                ) {
                    <mat-card
                        [formGroupName]="i"
                        class="tw-mb-3 tw-w-fit">
                        <mat-card-content
                            class="tw-flex tw-flex-col tw-items-center tw-p-4">
                            <span class="tw-text-md tw-font-medium">{{
                                carrier.get('name')?.value
                            }}</span>
                            <mat-form-field
                                class="tw-w-24 tw-h-[65px]"
                                floatLabel="always">
                                <input
                                    matInput
                                    type="number"
                                    [id]="'quantity-' + i"
                                    formControlName="quantity"
                                    min="0"
                                    class="tw-text-right" />
                            </mat-form-field>
                            <span
                                #tooltip
                                class="tw-text-sm tw-text-gray-600 tw-cursor-pointer"
                                (mouseenter)="
                                    showCustomTooltip(
                                        carrier.get('name')?.value,
                                        tooltip
                                    )
                                "
                                (mouseleave)="closeCustomTooltip()">
                                {{
                                    getStoredTotalForCarrier(
                                        carrier.get('name')?.value
                                    )
                                }}
                                /
                                {{
                                    getCarrierTotal(carrier.get('name')?.value)
                                }}
                            </span>
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        </form>
    }

    <!-- Totals section shown when no articleId -->
    @if (!articleId()) {
        <div class="tw-flex tw-flex-wrap tw-gap-4">
            @for (carrier of carriers.controls; track carrier; let i = $index) {
                <div class="tw-flex tw-flex-col tw-items-center tw-w-24">
                    <div class="tw-mb-2 tw-font-medium">
                        {{ carrier.get('name')?.value }}
                    </div>
                    <span
                        #tooltip
                        class="tw-text-sm tw-text-gray-600 tw-cursor-pointer"
                        (mouseenter)="
                            showCustomTooltip(
                                carrier.get('name')?.value,
                                tooltip
                            )
                        "
                        (mouseleave)="closeCustomTooltip()">
                        {{
                            getStoredTotalForCarrier(carrier.get('name')?.value)
                        }}
                        /
                        {{ getCarrierTotal(carrier.get('name')?.value) }}
                    </span>
                </div>
            }
        </div>
    }
</div>
